(function () {
    function initProductRelated(sectionElement) {
        if (!sectionElement || sectionElement.dataset.initialized === 'true') {
            return;
        }

        var sliderElement = sectionElement.querySelector('[data-product-related-swiper]');

        if (!sliderElement || typeof window.Swiper === 'undefined') {
            return;
        }

        sectionElement.dataset.initialized = 'true';

        var previousButton = sectionElement.querySelector('[data-product-related-prev]');
        var nextButton = sectionElement.querySelector('[data-product-related-next]');
        var slideCount = sliderElement.querySelectorAll('.swiper-slide').length;
        var isHomeSlider = sectionElement.classList.contains('filadelfia-product-related--home');
        var mobileSlides = isHomeSlider ? 2.3 : (Number(sectionElement.dataset.productRelatedMobileSlides) || 1);
        var mobileSlidesGroup = isHomeSlider ? 1 : mobileSlides;
        var tabletSlides = Number(sectionElement.dataset.productRelatedTabletSlides) || 2;
        var desktopSlides = Number(sectionElement.dataset.productRelatedDesktopSlides) || 3;

        if (slideCount <= 1) {
            if (previousButton) {
                previousButton.hidden = true;
            }

            if (nextButton) {
                nextButton.hidden = true;
            }

            return;
        }

        new window.Swiper(sliderElement, {
            slidesPerView: mobileSlides,
            slidesPerGroup: mobileSlidesGroup,
            spaceBetween: 26,
            speed: 700,
            breakpoints: {
                750: {
                    slidesPerView: tabletSlides,
                    slidesPerGroup: tabletSlides,
                    spaceBetween: 10
                },
                1100: {
                    slidesPerView: desktopSlides,
                    slidesPerGroup: desktopSlides,
                    spaceBetween: 10
                }
            },
            navigation: previousButton && nextButton ? {
                prevEl: previousButton,
                nextEl: nextButton
            } : undefined
        });
    }

    window.filadelfiaProductRelated = {
        init: initProductRelated
    };
})();
